module.exports = __webpack_public_path__ + "static/media/Health Hazard.8f03c33c.png";